const getImps = (margin) => {
    const m = Math.abs(margin);
    if (m <= 10) return 0;
    if (m <= 40) return 1;
    if (m <= 80) return 2;
    if (m <= 120) return 3;
    if (m <= 160) return 4;
    if (m <= 210) return 5;
    if (m <= 260) return 6;
    if (m <= 310) return 7;
    if (m <= 360) return 8;
    if (m <= 420) return 9;
    if (m <= 490) return 10;
    if (m <= 590) return 11;
    if (m <= 740) return 12;
    if (m <= 890) return 13;
    if (m <= 1090) return 14;
    if (m <= 1290) return 15;
    if (m <= 1490) return 16;
    if (m <= 1740) return 17;
    if (m <= 1990) return 18;
    if (m <= 2240) return 19;
    if (m <= 2490) return 20;
    if (m <= 2990) return 21;
    if (m <= 3490) return 22;
    if (m <= 3990) return 23;
    return 24; // 4000 or more
};

export const parseAliases = (csvString) => {
    if (!csvString) return {};
    const aliasMap = {};
    const lines = csvString.split('\n');
    lines.forEach(line => {
        const parts = line.split(',');
        if (parts.length >= 2) {
            const handle = parts[0].trim();
            const realName = parts.slice(1).join(',').trim(); 
            if (handle) aliasMap[handle] = realName;
        }
    });
    return aliasMap;
};

// 3. Standard Vulnerability Map
const VULNERABILITIES = [
    'None', 'NS', 'EW', 'Both', 
    'NS', 'EW', 'Both', 'None', 
    'EW', 'Both', 'None', 'NS', 
    'Both', 'None', 'NS', 'EW'
];
const getVul = (boardNum) => VULNERABILITIES[(boardNum - 1) % 16];

// 4. The Mini Bridge Scoring Engine
const calculateRawScore = (contractStr, boardNum) => {
    if (!contractStr || contractStr.trim() === '' || contractStr.toUpperCase() === 'P' || contractStr.toUpperCase() === 'PASS') return 0;

    // Parses string like "4SWx-2" or "3NN+1"
    const match = contractStr.trim().match(/^([1-7])([CDHSN])([NESW])(x|xx|)([-=+]?)(\d*)$/i);
    if (!match) return 0;

    const level = parseInt(match[1]);
    const suit = match[2].toUpperCase();
    const declarer = match[3].toUpperCase();
    const dbl = match[4].toLowerCase();
    const res = match[5];
    const tricks = match[6] ? parseInt(match[6]) : 0;

    const vulState = getVul(boardNum);
    const isVul = (declarer === 'N' || declarer === 'S') ? (vulState === 'NS' || vulState === 'Both') : (vulState === 'EW' || vulState === 'Both');

    // Base Points
    let basePoints = 0;
    if (suit === 'C' || suit === 'D') basePoints = 20 * level;
    else if (suit === 'H' || suit === 'S') basePoints = 30 * level;
    else if (suit === 'N') basePoints = 40 + 30 * (level - 1);

    const multiplier = dbl === 'xx' ? 4 : dbl === 'x' ? 2 : 1;
    const contractPoints = basePoints * multiplier;

    let score = 0;

    if (res === '=' || res === '+') {
        const overtricks = res === '+' ? tricks : 0;
        
        // Game & Partscore Bonus
        if (contractPoints >= 100) score += isVul ? 500 : 300;
        else score += 50;

        // Slam Bonus
        if (level === 6) score += isVul ? 750 : 500;
        else if (level === 7) score += isVul ? 1500 : 1000;

        // Insult Bonus
        if (dbl === 'x') score += 50;
        else if (dbl === 'xx') score += 100;

        score += contractPoints;

        // Overtrick Points
        if (dbl === '') score += overtricks * (suit === 'C' || suit === 'D' ? 20 : 30);
        else if (dbl === 'x') score += overtricks * (isVul ? 200 : 100);
        else score += overtricks * (isVul ? 400 : 200);

    } else if (res === '-') {
        const u = tricks;
        if (dbl === '') {
            score = -(u * (isVul ? 100 : 50));
        } else if (dbl === 'x') {
            if (!isVul) {
                let pen = 100;
                if (u >= 2) pen += 200;
                if (u >= 3) pen += 200;
                if (u >= 4) pen += (u - 3) * 300;
                score = -pen;
            } else {
                let pen = 200;
                if (u >= 2) pen += 300;
                if (u >= 3) pen += (u - 2) * 300;
                score = -pen;
            }
        } else if (dbl === 'xx') {
            if (!isVul) {
                let pen = 200;
                if (u >= 2) pen += 400;
                if (u >= 3) pen += 400;
                if (u >= 4) pen += (u - 3) * 600;
                score = -pen;
            } else {
                let pen = 400;
                if (u >= 2) pen += 600;
                if (u >= 3) pen += (u - 2) * 600;
                score = -pen;
            }
        }
    }

    // Return strictly from N/S Perspective (+ means N/S scored, - means E/W scored)
    return (declarer === 'N' || declarer === 'S') ? score : -score;
};

// 5. The Main LIN Parser
export const parseLin = (linString, aliases = {}) => {
    if (!linString || typeof linString !== 'string') throw new Error("Invalid LIN data provided.");

    // FIX: Strip all hidden newlines so tags like '\nrs' become clean 'rs' tags
    const cleanedLin = linString.replace(/[\r\n]+/g, '');
    const tokens = cleanedLin.split('|');
    const parsedData = {
        title: "Match",
        startBoard: 1,
        team1Name: "Team 1",
        team2Name: "Team 2",
        players: [],
        total_imps1: 0,
        total_imps2: 0,
        boards: [] 
    };

    // Extract Metadata (vg)
    const vgIndex = tokens.indexOf('vg');
    if (vgIndex !== -1 && tokens.length > vgIndex + 1) {
        const vgData = tokens[vgIndex + 1].split(',');
        if (vgData.length >= 7) {
            parsedData.title = vgData[0];
            parsedData.startBoard = parseInt(vgData[3]) || 1;
            parsedData.team1Name = vgData[5];
            parsedData.team2Name = vgData[7];
        }
    }

    // Extract Players (pn) & Apply Aliases
    const pnIndex = tokens.indexOf('pn');
    if (pnIndex !== -1 && tokens.length > pnIndex + 1) {
        const rawPlayers = tokens[pnIndex + 1].split(',');
        parsedData.players = rawPlayers.map(p => aliases[p.trim()] || p.trim());
    }

    // --- NEW: Extract Rich Data (Hands, Bidding, Play) sequentially ---
    const richData = {}; // Stores details by board number
    let currRoom = null; // 'o' for Open, 'c' for Closed
    let currBoard = null;

    for (let i = 0; i < tokens.length; i++) {
        const key = tokens[i];
        const val = tokens[i + 1];

        // qx marks the start of a specific board in a specific room (e.g., "o11" or "c11")
        if (key === 'qx' && val) {
            currRoom = val.charAt(0).toLowerCase(); 
            const bNumMatch = val.match(/\d+/);
            currBoard = bNumMatch ? parseInt(bNumMatch[0]) : null;
            
            if (currBoard && !richData[currBoard]) {
                richData[currBoard] = { 
                    o: { hands: '', bidding: [], play: [], claim: '', players: [], alerts: [] }, 
                    c: { hands: '', bidding: [], play: [], claim: '', players: [], alerts: [] } 
                };
            }
        } 
        // If we are actively tracking a board, collect its data
        else if (currBoard && currRoom && richData[currBoard][currRoom]) {
            if (key === 'pn') richData[currBoard][currRoom].players = val.split(',').map(p => aliases[p.trim()] || p.trim());
            else if (key === 'md') richData[currBoard][currRoom].hands = val;
            // else if (key === 'mb') richData[currBoard][currRoom].bidding.push(val);
            else if (key === 'mb') {
                richData[currBoard][currRoom].bidding.push(val);
                richData[currBoard][currRoom].alerts.push(''); // Keep alerts array perfectly in sync!
            }
            else if (key === 'an') {
                const alertsArr = richData[currBoard][currRoom].alerts;
                if (alertsArr.length > 0) alertsArr[alertsArr.length - 1] = val || 'Alert';
            }
            else if (key === 'pc') richData[currBoard][currRoom].play.push(val);
            else if (key === 'mc') richData[currBoard][currRoom].claim = val;
        }
    }

    // --- Extract Results (rs) & Tie Everything Together ---
    const rsIndex = tokens.indexOf('rs');
    if (rsIndex !== -1 && tokens.length > rsIndex + 1) {
        const rsData = tokens[rsIndex + 1].split(',');
        let currentBoard = parsedData.startBoard;

        // NEW: Sets to permanently track which humans belong to which physical room
        const originalOpen = new Set();
        const originalClosed = new Set();

        // The rs array is pairs of [Room 1, Room 2]
        for (let i = 0; i < rsData.length; i += 2) {
            let room1Contract = rsData[i] || "";
            let room2Contract = rsData[i + 1] || "";
            
            // Handle explicitly omitted boards
            if (room1Contract === "" && room2Contract === "") {
                parsedData.boards.push({
                    boardNum: currentBoard, room1: "", room2: "", rawMargin: 0, imps1: 0, imps2: 0, isOmitted: true,
                    details: richData[currentBoard] || { o: null, c: null } 
                });
                currentBoard++;
                continue;
            }

            // --- SMART ROOM SWAP DETECTION (THE PINNING ENGINE) ---
            let isSwapped = false;
            const oPlayers = richData[currentBoard]?.o?.players || [];
            const cPlayers = richData[currentBoard]?.c?.players || [];

            // 1. Are there any known "Closed" humans sitting in the "Open" room?
            const oHasClosedHuman = oPlayers.some(p => p && !p.startsWith('~') && originalClosed.has(p));
            // 2. Are there any known "Open" humans sitting in the "Closed" room?
            const cHasOpenHuman = cPlayers.some(p => p && !p.startsWith('~') && originalOpen.has(p));

            if (oHasClosedHuman || cHasOpenHuman) {
                isSwapped = true;
            }

            // 3. Register the humans for future boards to seamlessly handle mid-match substitutions!
            if (isSwapped) {
                // If it's swapped, the BBO 'o' room is actually our physical Closed room
                oPlayers.forEach(p => { if (p && !p.startsWith('~')) originalClosed.add(p); });
                cPlayers.forEach(p => { if (p && !p.startsWith('~')) originalOpen.add(p); });
            } else {
                // Standard un-swapped layout
                oPlayers.forEach(p => { if (p && !p.startsWith('~')) originalOpen.add(p); });
                cPlayers.forEach(p => { if (p && !p.startsWith('~')) originalClosed.add(p); });
            }

            // 4. Perform the physical swap if BBO inverted the rooms
            if (isSwapped) {
                const tempContract = room1Contract;
                room1Contract = room2Contract;
                room2Contract = tempContract;

                if (richData[currentBoard]) {
                    const tempDetails = richData[currentBoard].o;
                    richData[currentBoard].o = richData[currentBoard].c;
                    richData[currentBoard].c = tempDetails;
                }
            }
            // --- END SMART DETECTION ---

            const raw1 = calculateRawScore(room1Contract, currentBoard); // Always Original Open
            const raw2 = calculateRawScore(room2Contract, currentBoard); // Always Original Closed

            // Team 1 Margin = (Room 1 N/S Score) - (Room 2 N/S Score)
            const team1Margin = raw1 - raw2;
            const imps = getImps(team1Margin);

            let imps1 = 0;
            let imps2 = 0;
            if (team1Margin > 0) { imps1 = imps; parsedData.total_imps1 += imps; }
            else if (team1Margin < 0) { imps2 = imps; parsedData.total_imps2 += imps; }

            parsedData.boards.push({
                boardNum: currentBoard,
                room1: room1Contract,
                room2: room2Contract,
                raw1: raw1, 
                raw2: raw2,
                rawMargin: team1Margin,
                imps1: imps1,
                imps2: imps2,
                isOmitted: false,
                swapped: isSwapped, // We expose this so your Admin UI can see if it auto-corrected!
                details: richData[currentBoard] || { o: null, c: null }
            });

            currentBoard++;
        }
    }

    return parsedData;
};